import type { FastifyRequest } from "fastify";
import type { IncomingMessage } from "http";
import Cookies from "js-cookie";
import type { NetworkOptions as BaseNetworkOptions } from "scmp-sdk/lib/relay/network";
import setCookieParser from "set-cookie-parser";

import { config } from "shared/data";
import { SCMPAccessTokenCookiesKey } from "shared/lib/account/consts";
import { isSsr, notEmpty } from "shared/lib/utils";

export type NetworkOptions = {
  cookies?: FastifyRequest["cookies"];
  credentials: BaseNetworkOptions["urlOptions"]["credentials"];
  urlOptions?: BaseNetworkOptions["urlOptions"];
};

export const createNetworkOptions = ({
  cookies = {},
  credentials,
  urlOptions,
}: NetworkOptions): BaseNetworkOptions => ({
  authOptions: {
    allowEmptyToken: true,
    token: _ => cookies[SCMPAccessTokenCookiesKey] ?? "",
    async tokenRefreshPromise() {
      const scmpUser = Cookies.get("scmp_user");
      if (isSsr() || !notEmpty(scmpUser)) return "";
      const { refreshToken } = await import("shared/lib/account/apis");
      const response = await refreshToken();
      if (!response) return "";
      const cookies = setCookieParser.parse(response as unknown as IncomingMessage);
      return cookies.find(cookie => cookie.name === SCMPAccessTokenCookiesKey)?.value ?? "";
    },
  },
  urlOptions: {
    credentials,
    headers: {
      apikey: config.graphql.contentService.apiKey,
    },
    method: "POST",
    url: config.graphql.contentService.host,
    ...urlOptions,
  },
});
